import { fileToBase64 } from "@/utils/file-upload";

export async function getUploadUrl(
  key: string,
  memberMeta?: {
    orgId: string;
    userId: string;
    token?: string;
  },
): Promise<string> {
  const url = memberMeta
    ? `/api/upload?key=${key}&orgId=${memberMeta.orgId}&userId=${memberMeta.userId}&token=${memberMeta.token}`
    : `/api/upload?key=${key}`;

  const response = await fetch(url, {
    method: "GET",
  });

  if (!response.ok) {
    const errorData = await response.json();
    throw new Error(errorData.error || "Failed to get signed upload Url");
  }

  const data = await response.json();
  return data.url;
}
/**
 * Uploads a file to the S3 and returns the URL
 * @param key The key to store the file under
 * @param file the file to upload
 */
export async function uploadFile(key: string, file: File) {
  const base64 = await fileToBase64(file);
  const response = await fetch("/api/upload", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      base64Image: base64,
      key,
      fileName: file.name,
      contentType: file.type,
    }),
  });

  if (!response.ok) {
    const errorData = await response.json();

    if (base64.length <= 2000) {
      return base64;
    } else {
      let msg = "Failed to upload file";
      if (errorData.details) {
        msg += `. ${errorData.details}`;
      } else if (errorData.error) {
        msg += `. ${errorData.error}`;
      }
      throw new Error(msg);
    }
  }
}
